module.exports = __webpack_public_path__ + "static/img/mjijinshouNew.d0b8caa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImg/mjijinshouNew.jpg
// module id = VSe/
// module chunks = 0